import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'
import { useBeforeUnload } from 'react-use'

import { type InputValues } from '../utils'

export type DocumentReportEditPromptProps = {}

export const DocumentReportEditPrompt = () => {
  const { t } = useTranslation()
  const message = t(
    'edited_content_has_not_been_saved_do_you_still_want_to_leave',
  )
  const {
    formState: { isDirty },
  } = useFormContext<InputValues>()

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  )

  useBeforeUnload(isDirty, message)
  React.useEffect(() => {
    if (blocker.state === 'blocked') {
      const isConfirmed = window.confirm(message)
      if (isConfirmed) {
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, message])

  return <></>
}
